import React, {useEffect, useState} from 'react';

const BackToTop = () =>{

  const [showScroll, setShowScroll] = useState(false)

  useEffect(() => {
    // console.log('useEffect')
    
    let offset = 720
    if (typeof window !== 'undefined') {
      offset = window.innerHeight * 0.75
    }
  
    const checkScrollTop = () => {
      if (!showScroll && window.pageYOffset > offset){
        setShowScroll(true)
      } else if (showScroll && window.pageYOffset <= offset){
        setShowScroll(false)
      }
    };
  
    const scrollTop = () =>{
      if (showScroll) {
        window.scrollTo({top: 0, behavior: 'smooth'});
      }
    };
  
    window.addEventListener('scroll', checkScrollTop)

    document.getElementById('back-to-top').addEventListener('click', scrollTop)
  });

  return (
    // <div className="back-to-top" onClick={scrollTop} style={{height: 50, display: showScroll ? 'block' : 'none'}}><img src="/images/top.svg" alt="Back to top" /></div>
    <div id="back-to-top" className="back-to-top" style={{opacity: showScroll ? '1.0' : '0.0'}}><img src="/images/top.svg" alt="Back to top" /></div>
  );
}

export default BackToTop;